import { createFileRoute } from "@tanstack/react-router";

import { AdminRevenue } from "@/features/admin";

/**
 * Admin Revenue — wire path ``/admin/revenue``.
 *
 * v1 reference: ``app/admin-v2/components/pages/RevenuePage.tsx`` (195 LoC).
 * BE: legacy ``GET /admin/revenue`` (``admin.py:404``).
 */
export const Route = createFileRoute("/_authed/_modal/admin/revenue")({
  component: AdminRevenue,
});
